export default __webpack_public_path__ + "alberta-filter.e4c52087b87505eb0bf2.svg";